var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermsConditions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0kxagwy4na)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .3c.706.242 1.348.64 1.879 1.164l1.656 1.658c.525.53.923 1.172 1.165 1.878H16V.3zM21 7v12a5.006 5.006 0 0 1-5 5H8a5.006 5.006 0 0 1-5-5V5a5.006 5.006 0 0 1 5-5h6v5a2 2 0 0 0 2 2h5zm-4.192 10.413a1 1 0 0 0-1.4-.222 4.587 4.587 0 0 1-2.273.809 1.347 1.347 0 0 1-.864-.345A3.025 3.025 0 0 0 10.439 17a5.86 5.86 0 0 0-3.046 1.206 1 1 0 1 0 1.214 1.588A3.952 3.952 0 0 1 10.439 19c.246 0 .371.078.7.3.57.45 1.274.697 2 .7a6.464 6.464 0 0 0 3.456-1.193 1 1 0 0 0 .213-1.394zM17 14a1 1 0 0 0-1-1H8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1zm0-4a1 1 0 0 0-1-1H8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1z",
    fill: "#5E6175"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0kxagwy4na"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsConditions);
export default __webpack_public_path__ + "static/media/termsConditions.c1f9ef86d638765924caf77f170b10cb.svg";
export { ForwardRef as ReactComponent };